import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';
import { isNull } from 'lodash';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  findData,
  recordFiltering,
} from '~/store/modules/tagcomrestricao/actions';

import MyForm from './form';

function TagComRestricao() {
  const redux = useSelector((state) => state.tagcomrestricao);

  const header = useMemo(
    () => [
      {
        id: 'tagrestricaotag',
        label: t('s.operacao.tagrestricao.tagrestricaotag'),
        filter: { type: 'text' },
      },
      {
        id: 'idveiculo',
        label: t('s.cadastro.veiculo.idveiculo'),
        filter: { type: 'text' },
      },
      {
        id: 'codigonomeposto',
        label: t('s.operacao.abastecimento.nomeposto'),
        filter: { type: 'text' },
      },
      {
        id: 'codigousuario',
        label: t('s.operacao.recebimento.idusuario'),
        filter: { type: 'text' },
      },
      {
        id: 'datarestricaotag',
        label: t('s.operacao.tagrestricao.datarestricaotag'),
        // filter: { type: 'text' },
        formatted: (value) =>
          isNull(value) ? '' : format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'datahorainclusaobaserestricaotag',
        label: t('s.operacao.tagrestricao.datahorainclusaobase'),
        // filter: { type: 'text' },
        formatted: (value) =>
          isNull(value) ? '' : format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
    ],
    []
  );

  const fieldlist = [
    'tagrestricaotag',
    'idveiculo',
    'codigonomeposto',
    'codigousuario',
    'datarestricaotag',
    'datahorainclusaobaserestricaotag',
  ];

  const substituirHeader = {
    tagrestricaotag: t('s.operacao.tagrestricao.tagrestricaotag'),
    idveiculo: t('s.cadastro.veiculo.idveiculo'),
    codigonomeposto: t('s.operacao.abastecimento.nomeposto'),
    codigousuario: t('s.operacao.recebimento.idusuario'),
    datarestricaotag: t('s.operacao.tagrestricao.datarestricaotag'),
    datahorainclusaobaserestricaotag: t(
      's.operacao.tagrestricao.datahorainclusaobase'
    ),
  };

  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findData}
      form={MyForm}
      keys="idrestricaotag"
      detach="tagrestricaotag"
      update={false}
      pdf
      excel
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'tagcomrestricao',
          formato,
          fields: fieldlist,
          headers: substituirHeader,
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: "Relatório de TAG's com Restrição",
        })
      }
    />
  );
}

export default TagComRestricao;
